import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { GtmStatsDataEntityInterface } from '../data/entity.interface';
import { GtmStatsDataTrackableInterface } from '../data/trackable.interface';
import { GtmStatsAdapterPromotion } from './promotion';
import { GtmStatsAdapterEcommerceImpressionOnScroll } from './ecommerce-impression-on-scroll';
import { GtmStatsAdapterEcommercePromotionImpression } from './ecommerce-promotion-impression';

export class GtmStatsAdapterEntityImpression implements StatsAdapterInterface {
  /**
   *
   * @param entity
   * @param context
   */
  constructor(protected entity: GtmStatsDataEntityInterface, protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataTrackableInterface[] {
    const data: GtmStatsDataTrackableInterface[] = [];

    // Regular impression
    data.push(new GtmStatsAdapterEcommerceImpressionOnScroll(this.entity).getData());

    // Promotion impression
    if (this.entity.promotion) {
      const promotion = new GtmStatsAdapterPromotion(this.entity).getData();
      data.push(new GtmStatsAdapterEcommercePromotionImpression(promotion).getData());
    }

    return data;
  }
}
